module.exports = __webpack_public_path__ + "static/media/Group 777.35857903.svg";